import { MapPin } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useConsent } from "@/components/ConsentContext";

const GOOGLE_MAPS_SRC =
  "https://www.google.com/maps?q=Eichklingenweg+7,+74613+Öhringen-Eckartsweiler,+Deutschland&z=12&output=embed";

export default function GoogleMapConsent() {
  const { consent, enableExternalMedia, openSettings } = useConsent();
  const mapsAllowed = consent?.externalMedia === true;

  if (mapsAllowed) {
    return (
      <iframe
        title="Standort Tür- und Torservice Britz"
        src={GOOGLE_MAPS_SRC}
        width="100%"
        height="100%"
        style={{ border: 0, display: "block" }}
        allowFullScreen
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
      />
    );
  }

  return (
    <div className="flex h-full min-h-72 flex-col items-center justify-center bg-zinc-50 px-5 text-center md:min-h-96">
      <div className="mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-primary/10 text-primary">
        <MapPin className="h-7 w-7" />
      </div>
      <p className="text-lg font-bold text-zinc-950">Google Maps ist deaktiviert</p>
      <p className="mt-2 max-w-xl text-sm leading-relaxed text-zinc-600">
        Um die Karte anzuzeigen, erlauben Sie bitte externe Medien. Dabei können Daten an Google übertragen werden.
      </p>
      <div className="mt-5 flex flex-col gap-2 sm:flex-row">
        <Button onClick={enableExternalMedia}>Google Maps laden</Button>
        <Button variant="outline" className="border-primary text-primary hover:bg-primary/5" onClick={openSettings}>
          Datenschutzeinstellungen
        </Button>
      </div>
    </div>
  );
}
